import { render, staticRenderFns } from "./weaponPage.vue?vue&type=template&id=72470d68&scoped=true"
import script from "./weaponPage.vue?vue&type=script&lang=js"
export * from "./weaponPage.vue?vue&type=script&lang=js"
import style0 from "./weaponPage.vue?vue&type=style&index=0&id=72470d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72470d68",
  null
  
)

export default component.exports